import { requireAuth } from '@/router/helpers';

// The following routes are for '/admin/documents' (Forms & Policies)

export default [
  {
    path: '/admin/documents/:docType',
    name: 'AdminDocumentList',
    component: () => import('@/views/Documents'),
    beforeEnter: requireAuth,
    meta: {
      isAdmin: true,
    },
  },

  // Create a new document
  {
    path: '/admin/documents/:docType/create',
    name: 'AdminDocumentCreate',
    components: {
      default: () => import('@/views/Documents'),
      panel: () => import('@/views/documents/DocumentCreate'),
    },
    beforeEnter: requireAuth,
    props: { default: true, panel: false },
    meta: {
      openPanel: true,
      isAdmin: true,
      // permissions: [`add_${this.docType}`],
    },
  },

  // Categories -> All
  {
    path: '/admin/documents/:docType/categories',
    name: 'AdminDocumentsCategories',
    component: () => import('@/views/admin/Categories'),
    beforeEnter: requireAuth,
    meta: {
      isAdmin: true,
    },
  },

  // Category -> Create
  {
    path: '/admin/documents/:docType/categories/create',
    name: 'CategoryCreate',
    components: {
      default: () => import('@/views/admin/Categories'),
      panel: () => import('@/views/admin/categories/CategoryEditCreate'),
    },
    beforeEnter: requireAuth,
    meta: {
      openPanel: true,
      isAdmin: true,
      // permissions:['add_new_policy_categories','add_new_form_categories']
    },
  },

  // Category -> Edit
  {
    path: '/admin/documents/:docType/categories/:categoryId/edit',
    name: 'CategoryEdit',
    components: {
      default: () => import('@/views/admin/Categories'),
      panel: () => import('@/views/admin/categories/CategoryEditCreate'),
    },
    beforeEnter: requireAuth,
    meta: {
      openPanel: true,
      isAdmin: true,
    },
  },

  // Tags -> All
  {
    path: '/admin/documents/:docType/tags',
    name: 'AdminDocumentsTags',
    component: () => import('@/views/admin/Tags'),
    beforeEnter: requireAuth,
    meta: {
      isAdmin: true,
    },
  },

  // Tags -> Create
  {
    path: '/admin/documents/:docType/tags/create',
    name: 'TagCreate',
    components: {
      default: () => import('@/views/admin/Tags'),
      panel: () => import('@/views/admin/tags/TagEditCreate'),
    },
    beforeEnter: requireAuth,
    meta: {
      openPanel: true,
      isAdmin: true,
      // permissions:['add_new_policy_categories','add_new_form_categories']
    },
  },

  // Tags -> Edit
  {
    path: '/admin/documents/:docType/tags/:id/edit',
    name: 'TagEdit',
    components: {
      default: () => import('@/views/admin/Tags'),
      panel: () => import('@/views/admin/tags/TagEditCreate'),
    },
    beforeEnter: requireAuth,
    meta: {
      openPanel: true,
      isAdmin: true,
    },
  },

  // List with Tab Filter
  {
    path: '/admin/documents/:docType/:tab',
    name: 'AdminDocumentListTab',
    component: () => import('@/views/Documents'),
    beforeEnter: requireAuth,
    meta: {
      isAdmin: true,
    },
  },

  // Document -> Preview
  {
    path: '/admin/documents/:docType/:id/preview',
    name: 'AdminDocumentPreview',
    components: {
      default: () => import('@/views/Documents'),
      panel: () => import('@/views/documents/DocumentPreview'),
    },
    beforeEnter: requireAuth,
    meta: {
      openPanel: true,
      isAdmin: true,
    },
  },

  {
    path: '/admin/documents/:docType/:id/version/:versionId',
    name: 'AdminDocumentVersionPreview',
    components: {
      default: () => import('@/views/Documents'),
      panel: () => import('@/views/documents/DocumentPreview'),
    },
    beforeEnter: requireAuth,
    meta: {
      openPanel: true,
      isAdmin: true,
    },
  },

  {
    path: '/admin/documents/:docType/:id/version/:versionId/approve',
    name: 'AdminDocumentVersionApprove',
    components: {
      default: () => import('@/views/Documents'),
      panel: () => import('@/views/documents/DocumentApprove'),
    },
    beforeEnter: requireAuth,
    meta: {
      openPanel: true,
      isAdmin: true,
    },
  },

  {
    path: '/admin/documents/:docType/:id/version/:versionId/reject',
    name: 'AdminDocumentVersionReject',
    components: {
      default: () => import('@/views/Documents'),
      panel: () => import('@/views/documents/DocumentReject'),
    },
    beforeEnter: requireAuth,
    meta: {
      openPanel: true,
      isAdmin: true,
    },
  },

  // Document -> Reject
  {
    path: '/admin/documents/:docType/:id/reject',
    name: 'AdminDocumentReject',
    components: {
      default: () => import('@/views/Documents'),
      panel: () => import('@/views/documents/DocumentReject'),
    },
    beforeEnter: requireAuth,
    meta: {
      openPanel: true,
      isAdmin: true,
    },
  },

  // Document -> Approve
  {
    path: '/admin/documents/:docType/:id/approve',
    name: 'AdminDocumentApprove',
    components: {
      default: () => import('@/views/Documents'),
      panel: () => import('@/views/documents/DocumentApprove'),
    },
    beforeEnter: requireAuth,
    meta: {
      openPanel: true,
      isAdmin: true,
    },
  },

  // Document -> Create new version
  {
    path: '/admin/documents/:docType/:id/create-version',
    name: 'AdminDocumentCreateVersion',
    components: {
      default: () => import('@/views/Documents'),
      panel: () => import('@/views/documents/DocumentCreateVersion'),
    },
    beforeEnter: requireAuth,
    meta: {
      openPanel: true,
      isAdmin: false,
    },
  },

  // Document -> Edit
  {
    path: '/admin/documents/:docType/:id/edit',
    name: 'AdminDocumentEdit',
    components: {
      default: () => import('@/views/Documents'),
      panel: () => import('@/views/documents/DocumentEdit'),
    },
    beforeEnter: requireAuth,
    meta: {
      openPanel: true,
      isAdmin: true,
    },
  },
  // Document -> Archive
  {
    path: '/admin/documents/:docType/:id/archive',
    name: 'AdminDocumentArchive',
    components: {
      default: () => import('@/views/Documents'),
      panel: () => import('@/views/documents/DocumentArchive'),
    },
    beforeEnter: requireAuth,
    meta: {
      openPanel: true,
      isAdmin: true,
    },
  },

  {
    path: '/admin/documents/:docType/:id/version/:versionId/edit',
    name: 'AdminDocumentVersionEdit',
    components: {
      default: () => import('@/views/Documents'),
      panel: () => import('@/views/documents/DocumentVersionEdit'),
    },
    beforeEnter: requireAuth,
    meta: {
      openPanel: true,
      isAdmin: true,
    },
  },
];
